import {companyFeaturesConstants} from '../../constants';
import {useCompanyFeatureAvailable} from './useCompanyFeatureAvailable';

const featureName = companyFeaturesConstants.BUDGETS_PO_AVAILABLE;

/**
 * Checks if the budgets / purchase orders module is available for the company.
 *
 * @returns {boolean} True when the `budgets_po_available` company feature is enabled.
 *
 * @example
 * const isBudgetsAvailable = useIsBudgetsAvailable();
 */
export const useIsBudgetsAvailable = () => {
  return useCompanyFeatureAvailable(featureName);
};
